<!--
 * @Author: 仙道
 * @Date: 2022-06-06 22:41:13
 * @LastEditTime: 2022-06-07 19:24:34
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/tech/assay/index.vue
-->
<template>
  <a-card :bordered="false">
    <a-form-model
      :label-col="{ span: 10}"
      :model="queryModel"
      :wrapper-col="{ span: 14 }"
      @submit="handleSumbit"
      layout="inline"
    >
      <a-form-item label="取样点名称">
        <a-input placeholder="请输入取样点名称" v-model="queryModel.processName" />
      </a-form-item>
      <a-form-item>
        <a-button html-type="submit" type="primary">查询</a-button>
      </a-form-item>
    </a-form-model>
    <div class="grid"></div>
    <a-row :gutter="24">
      <a-col :span="12">
        <assay-table />
      </a-col>
      <a-col :span="12">
        <assay-table />
      </a-col>
    </a-row>
  </a-card>
</template>
assay

<script>
  import { mapGetters } from 'vuex'
  import AssayTable from './module/table.vue'
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'AssayList',
    components: {
      AssayTable
    },
    // 定义属性
    data () {
      return {
        queryModel: {

        },
        request: {
          list: '/exam/techExamSamplepos/list'
        }
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.handleQueryList()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      handleSumbit () { },
      handleQueryList () {
        getAction(this.request.list, '').then(res => {
          this.listData = res.result.records
        })
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>